import * as selectors from './selectors'

export const metadataSelectors = selectors
